// BUG-2583: amounts for a Customer Wallet / Gift Card top-up payment.
//
// When the cashier presses Enter on an integrated Card / UPI top-up payment, the attempt is
// recorded in localStorage ("walletDataForCardIntegration" for the wallet,
// "giftCardIntegrationTopupData" for a gift card). The EDC popup and the post-payment handlers
// already read the amount from that record. "Manual entry (Override)" must use the same amount:
// it used to read the Card amount box for every method, which is empty for UPI, so the payment
// was stored as NaN and sent to the server as amount: null.

const positiveNumber = (value) => {
  const n = typeof value === "number" ? value : parseFloat(value);
  return Number.isFinite(n) && n > 0 ? n : null;
};

const readRecord = (key) => {
  try {
    return JSON.parse(localStorage.getItem(key));
  } catch (e) {
    console.error(`[BUG-2583] ${key} could not be read`, e);
    return null;
  }
};

// Amount of the recorded top-up attempt for this payment method, or null when there is no
// record, the record is for another method, or its amount is not a positive number.
export const readTopupAttemptAmount = ({ giftCardTopup, paymentMethod }) => {
  if (giftCardTopup) {
    const record = readRecord("giftCardIntegrationTopupData");
    if (!record) return null;
    if (record.paymentMethod && paymentMethod?.name && record.paymentMethod !== paymentMethod.name) return null;
    return positiveNumber(record.paymentValue);
  }
  const record = readRecord("walletDataForCardIntegration");
  if (!record) return null;
  const recordedId = record.selectedPaymentMethod?.finPaymentmethodId;
  if (recordedId && paymentMethod?.finPaymentmethodId && recordedId !== paymentMethod.finPaymentmethodId) return null;
  return positiveNumber(record.paymentAmount);
};

// Amount to complete a manual (override) top-up payment with: the recorded attempt, else the
// Card amount box (the only source before BUG-2583). No other value is guessed: with neither,
// completePayment rejects the payment.
export const resolveManualTopupAmount = ({ giftCardTopup, paymentMethod, cardInput }) => {
  const recorded = readTopupAttemptAmount({ giftCardTopup, paymentMethod });
  return recorded !== null ? recorded : cardInput;
};

// True when any collected top-up payment has no usable amount. Such a payment must never be
// sent: the server rejects the whole top-up (fin_receiptline.amount is NOT NULL).
export const hasInvalidTopupPaymentAmount = (payments) => (Array.isArray(payments) ? payments : []).some((p) => positiveNumber(p?.amount) === null);

export const TOPUP_PAYMENT_AMOUNT_MISSING = "Payment amount is missing. Remove the payment and add it again.";
